module.exports = __webpack_public_path__ + "product.variant-gallery-9e6e4595.html";